import * as Yup from "yup";
import checkout, { createUserForm } from "./form";

const {
  formField: {
    name,
    members,
    email,
    introduction,
    accountNumber,
    phone,
    taxCode,
    address,
    logo,
    actionType,
    bankBranch,
    bankOwner,
  },
} = checkout;

const {
  formField: { email: emailUser, company },
} = createUserForm;

const validations = Yup.object().shape({
  // [introduction.name]: Yup.string(),
  [logo.name]: Yup.mixed().required(logo.errorMsg),
  [name.name]: Yup.string().required(name.errorMsg),
  // [bankBranch.name]: Yup.string().required(bankBranch.errorMsg),
  // [bankOwner.name]: Yup.string().required(bankOwner.errorMsg),
  // [address.name]: Yup.string().required(address.errorMsg),
  // [members.name]: Yup.string().required(members.errorMsg),
  // [actionType.name]: Yup.string().required(actionType.errorMsg),
  // [accountNumber.name]: Yup.string()
  //   .matches(/^[0-9]{9,18}$/, accountNumber.invalidMsg)
  //   .required(accountNumber.errorMsg),
  [email.name]: Yup.string().when([], (schema) => {
    const urlContainsCreate = window.location.href.includes("create");
    const urlContainsEdit = window.location.href.includes("edit");
    if (urlContainsCreate) {
      return schema.required(email.errorMsg).email(email.invalidMsg);
    } else if (urlContainsEdit) {
      return schema.notRequired();
    }

    return schema;
  }),
  // [phone.name]: Yup.string()
  //   .matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg)
  //   .required(phone.errorMsg),
  [taxCode.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxCode.invalidMsg)
    .required(taxCode.errorMsg),
});

const validationCreateUser = Yup.object().shape({
  [emailUser.name]: Yup.string().required(emailUser.errorMsg).email(emailUser.invalidMsg),
});

export { validationCreateUser };

export default validations;
